<form [formGroup]="formGroup">
<div class="row">
  <div *ngIf="placeholder && showLabel" [class.col-12]="!inline && multiLine" [class.col-3]="inline && multiLine">
    <label class="form-label" >{{placeholder}}</label>
  </div>
  <div [class.col-12]="!inline && multiLine" [class.col-9]="inline && multiLine" [class.col-6]="!multiLine">

    <app-multi-select-with-static-options
      name="relative_date"
      [placeholder]="'table_filter.select_timeframe' | translate"
      [multi]="false"
      [formControl]="formGroup.controls.relative_date"
      [selectOptions]="dateSelector">
    </app-multi-select-with-static-options>
  </div>
  <div *ngIf="formGroup.controls.relative_date.value === 'from_until'"
       [class.mt-1]="multiLine"
       [class.col-4]="inline && multiLine"
       [class.offset-3]="inline && multiLine"
       [class.col-6]="!inline && multiLine"
       [class.col-3]="!multiLine"
  >
    <app-date-time
      class="w-100"
      name="{{ name }}_min"
      [formControl]="$any(formGroup.controls.min)"
      [timeMode]="TIME_MODE.START_OF_DAY"
      [placeholder]="'table_filter.from_date_placeholder' | translate"
      [small]="true"
    ></app-date-time>
  </div>

  <div *ngIf="formGroup.controls.relative_date.value === 'from_until'"
       [class.mt-1]="multiLine"
       [class.col-5]="inline && multiLine"
       [class.col-6]="!inline && multiLine"
       [class.col-3]="!multiLine"
  >
    <app-date-time
      class="w-100"
      name="{{ name }}_max"
      [formControl]="$any(formGroup.controls.max)"
      [timeMode]="TIME_MODE.END_OF_DAY"
      [placeholder]="'table_filter.until_date_placeholder' | translate"
      [small]="true"
    ></app-date-time>
  </div>
</div>
</form>
